import { Route, Switch } from "react-router-dom";
import ArrecadaoListagemPages from "./Listagem";

function ArrecadaoPages() {
  return (
    <Switch>
      <Route
        path="/financeiro/receita/arrecadacoes"
        component={ArrecadaoListagemPages}
      />
    </Switch>
  );
}

export default ArrecadaoPages;
